export default __webpack_public_path__ + "static/AQP-7faa263a2d7a43607eecfcfd1880b868.svg";